export default "__VITE_ASSET__BrjLGysb__"